import React, { useEffect, useState, useContext } from 'react';
import { UserContext } from '../UserContext';
import { useNavigate } from 'react-router-dom';
import { useApi } from '../ApiContext';
import FormActionButton from '../components/FormActionButton';
import Container from '../components/Container';
import Heading2 from '../components/Heading2';

function log(...args: any[]): void {
  console.log('AddPaymentCardScreena', ...args);
}

// @deprecated
// could not get the embedded iframe to reliably redirect back into this app
// so we opted for the full-screen payment form instead, `AddPaymentCardScreenA`.
const AddPaymentCardScreenA: React.FC = () => {
  const userContext = useContext(UserContext);
  const navigate = useNavigate();
  const api = useApi();
  const [isLoading, setIsLoading] = useState(false);
  const [paymentFormUrl, setPaymentFormUrl] = useState<string | null>(null);

  useEffect(() => {
    log('begin useEffect fetchPaymentForm');
    const fetchPaymentForm = async () => {
      log('begin fetchPaymentForm', userContext?.userData);
      setIsLoading(true);
      const { data, error } = await api.client.getPaymentFormUrl({
        customer_id: userContext?.userData.customer_id || '',
        provider_id: userContext?.userData.provider_id || '',
        redirect_uri: window.location.href,
        billing_info: userContext?.userData.billingInfo,
      });
      log('fetchPaymentForm', data, error);
      if (data?.url) {
        setPaymentFormUrl(data.url);
      } else {
        // TODO: handle failure to get url
      }
      setIsLoading(false);
      log('end fetchPaymentForm');
    };

    const url = userContext?.userData.paymentFormUrl;
    if (url) {
      setPaymentFormUrl(url);
    } else {
      fetchPaymentForm();
    }
  }, [userContext, api.client]);

  const handlePaymentSuccess = async () => {
    log('begin handlePaymentSuccess');
    setIsLoading(true);
    await api.submitForm();
    setIsLoading(false);
    navigate('/confirm-appointment');
    log('end handlePaymentSuccess');
  };

  useEffect(() => {
    log('begin useEffect handlePaymentMessage');
    const handlePaymentMessage = async (event: MessageEvent) => {
      log('begin handlePaymentMessage', event.data);
      if (event.data === 'payment-success') {
        setIsLoading(true);
        await api.submitForm();
        setIsLoading(false);
        navigate('/confirm-appointment');
      }
      log('end handlePaymentMessage');
    };

    window.addEventListener('message', handlePaymentMessage);

    return () => {
      window.removeEventListener('message', handlePaymentMessage);
    };
  }, [navigate, api]);

  const handleFrameLoadEvent = () => {
    log('begin handleFrameLoadEvent');
    // Get the iframe element
    const iframe = document.getElementById('external-payment-form') as HTMLIFrameElement;
    if (iframe) {
      console.log('found iframe . . .');
      try {
        // If the redirect is back to our app and our domain we will be able to access the href property.
        const url = iframe.contentWindow?.location.href;
        // If we could access the href, then the app is trying to send the user to the next step.
        console.log('url', url);
        navigate('/confirm-appointment');
      } catch (error) {
        // Catch potential cross-origin access errors
        console.error('Cross-origin access error:', error);
      }
    } else {
      console.log('NO iframe found :(');
    }
    log('end handleFrameLoadEvent');
  };

  function paymentForm(url: string) {
    console.log('should show url', url);
    return (
      <>
        {' '}
        <iframe
          id="external-payment-form"
          src={url}
          title="Payment"
          style={{ width: '100%', height: '500px' }}
          onLoad={handleFrameLoadEvent}
        ></iframe>
        <div className="flex justify-center mt-8">
          <FormActionButton onClick={handlePaymentSuccess} isLoading={isLoading}>
            {isLoading ? 'Processing...' : 'Simulate Payment Success'}
          </FormActionButton>
        </div>
      </>
    );
  }
  return (
    <Container>
      <Heading2>Enter Payment Details</Heading2>
      <p className="text-gray-700 mb-6 text-center">Our billing process is fully secure. 🔒</p>
      {paymentFormUrl ? (
        paymentForm(paymentFormUrl)
      ) : (
        <div className="flex justify-center mt-8">
          <p className="text-gray-700 mb-6 text-center">{'Loading . . .'}</p>
        </div>
      )}
    </Container>
  );
};

export default AddPaymentCardScreenA;
